import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "finance-section" }
const _hoisted_2 = { class: "section-header" }
const _hoisted_3 = {
  key: 0,
  class: "total-charge"
}
const _hoisted_4 = { class: "total-amount" }
const _hoisted_5 = { class: "tab-content" }
const _hoisted_6 = {
  key: 0,
  class: "receipt-section"
}
const _hoisted_7 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_8 = {
  key: 1,
  class: "receipt-breakdown"
}
const _hoisted_9 = { class: "item-label" }
const _hoisted_10 = { class: "item-amount" }
const _hoisted_11 = {
  key: 2,
  class: "no-data"
}
const _hoisted_12 = {
  key: 1,
  class: "no-trip-selected"
}
const _hoisted_13 = {
  key: 2,
  class: "pagination-container"
}

import { ref, onMounted } from 'vue'
import { getTripReceipt, type ReceiptItem } from '@/api/ev-trips'
import { ElMessage } from 'element-plus'
import { parseErrors } from '@/helpers/error-parsers'
import * as evReservesApi from '@/api/ev-reserves'
import EvReserveTransactionsTable from '@/components/EvReserveTransactionsTable.vue'

interface Props {
  carId: string
  selectedTripId?: string | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FinanceSection',
  props: {
    carId: {},
    selectedTripId: {}
  },
  setup(__props: any) {

const props = __props

const reserveTransactions = ref<any[]>([])
const loadingReserveTransactions = ref(false)
const receiptData = ref<ReceiptItem[]>([])
const loadingReceipt = ref(false)
const selectedTripId = ref<string | null>(props.selectedTripId || null)

// Pagination state
const currentPage = ref(1)
const perPage = ref(20)
const totalTransactions = ref(0)
const totalPages = ref(0)
const totalChargeAzn = ref(0)

const loadReceipt = async (tripId: string) => {
  if (!tripId) return

  try {
    loadingReceipt.value = true
    const response = await getTripReceipt(tripId)
    receiptData.value = response.data.data || []
  } catch (error) {
    console.error('❌ Failed to load receipt:', error)
    const { error: errorMessage } = parseErrors(error)
    ElMessage.error(errorMessage || 'Failed to load receipt')
  } finally {
    loadingReceipt.value = false
  }
}

const loadReserveTransactions = async (page: number = currentPage.value) => {
  if (!props.carId) return

  try {
    loadingReserveTransactions.value = true

    const response = await evReservesApi.getCarTransactions(props.carId, {
      page,
      limit: perPage.value,
    })

    const responseData = response.data.data

    const transactionsData = responseData.transactions

    reserveTransactions.value = transactionsData.data || []
    totalTransactions.value = transactionsData.meta?.total || 0
    totalPages.value =
      transactionsData.meta?.lastPage ??
      transactionsData.meta?.last_page ??
      Math.ceil(totalTransactions.value / perPage.value)
    currentPage.value =
      transactionsData.meta?.currentPage ??
      transactionsData.meta?.current_page ??
      page

    totalChargeAzn.value = responseData.total_charge_azn || 0
  } catch (error) {
    console.error('❌ Failed to load reserve transactions:', error)
    const { error: errorMessage } = parseErrors(error)
    ElMessage.error(errorMessage || 'Failed to load reserve transactions')
  } finally {
    loadingReserveTransactions.value = false
  }
}

const handlePageChange = async (page: number) => {
  currentPage.value = page
  await loadReserveTransactions(page)
}

const handlePerPageChange = async (size: number) => {
  perPage.value = size
  currentPage.value = 1
  await loadReserveTransactions(1)
}

onMounted(() => {
  if (selectedTripId.value) {
    loadReceipt(selectedTripId.value)
  }
  loadReserveTransactions()
})

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "section-title" }, "FINANCE", -1)),
      (totalChargeAzn.value > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "total-label" }, "Total Charge:", -1)),
            _createElementVNode("span", _hoisted_4, _toDisplayString(totalChargeAzn.value.toFixed(2)) + " ₼", 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (selectedTripId.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "tab-header" }, [
              _createElementVNode("h5", null, "Price Breakdown"),
              _createElementVNode("p", { class: "tab-description" }, " Receipt details for selected trip ")
            ], -1)),
            (loadingReceipt.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[4] || (_cache[4] = [
                  _createElementVNode("p", null, "Loading receipt...", -1)
                ])))
              : (receiptData.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(receiptData.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass(["breakdown-item", { 'total-item': item.isTotal }])
                      }, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(item.label) + ":", 1),
                        _createElementVNode("span", _hoisted_10, "₼" + _toDisplayString(item.amount.toFixed(2)), 1)
                      ], 2))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[5] || (_cache[5] = [
                    _createElementVNode("p", null, "No receipt data available", -1)
                  ])))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[7] || (_cache[7] = [
            _createElementVNode("p", null, "Select a trip to view receipt details", -1)
          ]))),
      _cache[8] || (_cache[8] = _createElementVNode("div", {
        class: "tab-header",
        style: {"margin-top":"30px"}
      }, [
        _createElementVNode("h5", null, "EV Reserve Transactions"),
        _createElementVNode("p", { class: "tab-description" }, " Transactions related to EV reserves for this car ")
      ], -1)),
      _createVNode(EvReserveTransactionsTable, {
        transactions: reserveTransactions.value,
        loading: loadingReserveTransactions.value
      }, null, 8, ["transactions", "loading"]),
      (reserveTransactions.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(_component_el_pagination, {
              "current-page": currentPage.value,
              "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
              "page-size": perPage.value,
              "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((perPage).value = $event)),
              total: totalTransactions.value,
              layout: "total, sizes, prev, pager, next",
              "page-sizes": [10, 20, 50, 100],
              "hide-on-single-page": false,
              onCurrentChange: handlePageChange,
              onSizeChange: handlePerPageChange,
              background: ""
            }, null, 8, ["current-page", "page-size", "total"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})